<template>
  <div class="cancellation-detail">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="toPurchaseReturn">退货单/</span>退货详情
      </template>
      <template v-slot:content>
        <div class="cancellation-detail-main">
          <div class="header" ref="steps">
            <ul>
              <li>退单号：{{ data.refundCode }}</li>
              <li>客户名称：{{ data.xbName }}</li>
            </ul>
            <ul>
              <li>下单时间：{{ data.createTime }}</li>
              <li>当前退货状态：{{ data.statusValue }}</li>
            </ul>
            <div class="right">
              <span>关联订单号:</span>
              <span class="package" v-if="data.setMealId">套餐</span>
              <span class="code" @click="goCodeDetail(data.code)">{{data.code}}</span>
            </div>
          </div>
          <div class="table-img">
            <el-table :data="tableData">
              <el-table-column label="商品名称">
                <template slot-scope="scope">
                  <img class="img" :src="scope.row.goodsPic" />
                  <p class="name">{{ scope.row.goodsName }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="specifications" label="规格" width="208"></el-table-column>
              <el-table-column prop="goodsUnitPrice" label="单价" width="208"></el-table-column>
              <el-table-column prop="quantity" label="数量" width="208">
                <template slot-scope="scope">
                  <el-input class="gray" v-model.number="scope.row.quantity" v-if="inputVisible"></el-input>
                  <span v-else>{{scope.row.quantity}}</span>
                </template>
              </el-table-column>
              <el-table-column label="小计" width="208">
                <template slot-scope="scope">
                  <span>{{scope.row.quantity * scope.row.goodsUnitPrice*100/100}}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="total">
              <ul class="ul-list">
                <li class="list">
                  <p>订单合计：</p>
                  <span>{{ sum }}</span>
                </li>
                <li class="list">
                  <p>应付金额：</p>
                  <el-input
                    v-model="data.realRefundMoney"
                    placeholder="金额"
                    v-if="inputVisible"
                    class="gray"
                  ></el-input>
                  <span v-else>{{ data.realRefundMoney}}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="message-title">
            <div class="tit">退款信息：</div>
            <div class="message">
              <ul class="ul-list" v-if="data.orderPaymentMethod ===4">
                <li class="list">退款将退回至原银行账户</li>
              </ul>
              <ul class="ul-list" v-else>
                <li class="list">
                  账户名称：
                  <span>{{ data.bankUser }}</span>
                </li>
                <li class="list">
                  开户银行：
                  <span>{{ data.bankName }}</span>
                </li>
                <li class="list">
                  银行账号：
                  <span>{{ data.bankAccount }}</span>
                </li>
              </ul>
              <ul class="ul-list">
                <li class="list">
                  退货地址：
                  <el-input
                    v-model="data.totalAddress"
                    placeholder="请输入地址"
                    v-if="inputVisible"
                    class="gray"
                  ></el-input>
                  <span v-else>{{ data.totalAddress }}</span>
                </li>
                <li class="list">
                  物流信息：
                  <span>{{ expressData.expressCode }}</span>
                  <el-button type="text" @click="dialogVisible = true">查看物流</el-button>
                  <el-dialog title="物流信息" :visible.sync="dialogVisible" width="400px" top="25vh">
                    <p class="border"></p>
                    <div class="container">
                      <div class="express">
                        <p class="express-p">{{ expressData.expressName }}</p>
                        <p class="express-p">单号：{{ expressData.expressCode }}</p>
                      </div>
                      <ul class="list" v-if="expressData.expressList.length>0">
                        <li v-for="(value,index) in expressData.expressList" :key="index">
                          <i></i>
                          <p class="space">{{value.content}}</p>
                          <p class="time">{{value.time}}</p>
                        </li>
                      </ul>
                      <p v-else>暂无物流信息</p>
                    </div>
                  </el-dialog>
                </li>
                <li class="list">
                  退货留言：
                  <span>{{ data.refundMessag }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="operations" ref="operations">
            <div class="button-container" v-if="inputVisible">
              <el-button class="btn-white" @click="cancel">取消</el-button>
              <el-button class="btn-blue" @click="save">保存</el-button>
            </div>
            <div class="button-container" v-else>
              <el-button class="btn-white" @click="toPurchaseReturn">返回</el-button>
              <el-button
                v-if="status === 0"
                class="btn-blue"
                @click="change"
                v-show="operationList.findIndex(item => item === operationsBtns.roleOrderCancelupdate) !== -1"
              >修改退单</el-button>
              <el-button class="btn-blue" v-if="status === 0" @click="examine">退单审核</el-button>
            </div>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import { getDBOperationPermission } from 'common/js/storage'; // 权限数据接口
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import DBOrder from 'models/db/order.js';
const dbOrder = new DBOrder();
export default {
  data() {
    return {
      operationList: [], // 权限列表数据
      // 页面按钮-- 退单修改
      operationsBtns: {
        roleOrderCancelupdate: 'ROLE_ORDER_cancel_update'
      },
      data: {
        refundCode: '', // 退单号
        code: '', // 订单号
        setMealId: '', // 套餐id
        xbName: '', // 名称
        createTime: '', // 订单创建时间
        statusValue: '', // 订单状态
        totalPrice: '', // 退单金额
        realRefundMoney: '', // 实际退货金额
        orderPaymentMethod: '', // 订单支付方式
        bankUser: '', // 账户名称
        bankName: '', // 开户银行
        bankAccount: '', // 银行账号
        totalAddress: '', // 退货地址
        refundMessag: '' // 退货留言
      },
      expressData: {
        expressCode: '暂无',
        expressName: '暂无',
        expressList: []
      },
      status: '',
      sum: 0,
      tableData: [
        // {
        //   itemId: 171,
        //   goodsUnitPrice: 120201,
        //   quantity: '1',
        //   itemTitle: '黑色4G华为6s手机',
        //   subtotal: 120201,
        //   goodsPic:
        //     'http://image.8844it.com/b2c-image/ydb2.0/201942417049644.jpg',
        //   id: 80,
        //   goodsName: '华为6s手机'
        // }
      ],
      dialogVisible: false,
      inputVisible: false
    };
  },
  components: {
    SecondMenuLinkContent
  },
  watch: {
    tableData: {
      handler(newName, oldName) {
        let sum = 0;
        newName.map((value, index, array) => {
          sum += (value.goodsUnitPrice * 100 * value.quantity) / 100;
        });
        this.sum = sum;
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.operationList = getDBOperationPermission();
  },
  mounted() {
    const paddingWidth = 48;
    this.$refs.operations.style.width =
      this.$refs.steps.clientWidth + paddingWidth + 'px';
    window.onresize = () => {
      if (this.$refs.operations) {
        this.$refs.operations.style.width =
          this.$refs.steps.clientWidth + paddingWidth + 'px';
      }
    };
  },
  beforeMount() {
    let refundCode = this.$route.query.refundCode;
    this.getDetail(refundCode);
    this.getLogisData(refundCode);
  },
  methods: {
    toPurchaseReturn() {
      this.$router.push('order-return');
    },
    // 获取详情数据
    getDetail(refundCode) {
      dbOrder.getDBRefundDetail(refundCode).then(res => {
        this.data.refundCode = res.result.refundOrder.refundCode;
        this.data.code = res.result.refundOrder.orderCode;
        this.data.setMealId = res.result.refundOrder.setMealId;
        this.data.xbName = res.result.refundOrder.xbName;
        this.data.createTime = this.fmtDate(res.result.refundOrder.createTime);
        this.data.statusValue = this.getStatusValue(
          res.result.refundOrder.status
        );
        this.data.totalPrice = res.result.refundOrder.totalPrice;
        this.data.orderPaymentMethod =
          res.result.refundOrder.orderPaymentMethod;
        this.data.realRefundMoney = res.result.refundOrder.realRefundMoney;
        this.data.bankUser = res.result.refundOrder.bankUser;
        this.data.bankName = res.result.refundOrder.bankName;
        this.data.bankAccount = res.result.refundOrder.bankAccount;
        this.data.totalAddress = res.result.refundAddress.totalAddress;
        this.data.refundMessag = res.result.refundOrder.refundMessage;
        // this.tableData = res.result.refundDetailList;
        this.status = res.result.refundOrder.status;
        let arr = [];
        res.result.refundDetailList.map((value, index, array) => {
          let obj = {};
          obj.goodsId = value.goodsId;
          obj.goodsPic = value.goodsPic
            ? value.goodsPic
            : 'http://image.8844it.com/ydb2/goodDefault.png';
          obj.goodsName = value.goodsName;
          obj.goodsUnitPrice = value.goodsUnitPrice;
          obj.quantity = value.quantity;
          let itemTitle = JSON.parse(value.itemTitle);
          let specifications = '';
          for (let key in itemTitle) {
            specifications += `,${itemTitle[key]}`;
          }
          obj.specifications = specifications.substring(1);
          arr.push(obj);
        });
        this.tableData = arr;
      });
    },
    // 获取状态码对应的值
    getStatusValue(index) {
      let status = [
        '待退货审核',
        '待退货',
        '待收货',
        '待退款',
        '待收款',
        '已完成',
        '已取消',
        '已拒绝'
      ];
      return status[index];
    },
    // 获取退单物流信息
    getLogisData(refundCode) {
      dbOrder.getDBLogisDetailByRefundCode(refundCode).then(res => {
        console.log(res);
        if (res.success) {
          if (res.result) {
            this.expressData.expressCode = res.result.LogisticCode;
            this.expressData.expressName = res.result.ExpressName;
            res.result.Traces.map(value => {
              let obj = {};
              obj.content = value.AcceptStation;
              obj.time = value.AcceptTime;
              this.expressData.expressList.unshift(obj);
            });
          }
        }
      });
    },
    // 关联订单
    goCodeDetail(code) {
      this.$router.push(
        `/admin/order/order-form/order-detail?orderCode=${code}`
      );
    },
    // 修改
    change() {
      this.inputVisible = !this.inputVisible;
    },
    // 取消修改
    cancel() {
      this.getDetail();
      this.inputVisible = !this.inputVisible;
    },
    // 保存修改
    save() {
      let refundCode = this.data.refundCode;
      let refundDetailList = [];
      let realRefundMoney = this.data.realRefundMoney;
      let refundAddress = {
        totalAddress: this.data.totalAddress
      };
      this.tableData.map((value, index, array) => {
        let obj = {};
        obj.quantity = value.quantity;
        obj.id = value.id;
        refundDetailList.push(obj);
      });
      dbOrder
        .postDBRefundModify(
          refundCode,
          refundDetailList,
          realRefundMoney,
          refundAddress
        )
        .then(res => {
          if (res.success) {
            this.$message.success('修改成功');
            this.inputVisible = !this.inputVisible;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    // 审核
    examine() {
      let code = this.data.refundCode;
      this.$confirm(`是否确认退单${code}通过退单审核`, '退单审核', {
        distinguishCancelAndClose: true,
        confirmButtonText: '通过审核',
        cancelButtonText: '不同意',
        type: 'warning'
      })
        .then(() => {
          let refundCode = code;
          let res = '1';
          dbOrder.postDBRefundExaminel(refundCode, res).then(res => {
            if (res.success) {
              this.$message.success('审核成功！');
              this.getRefundList();
            }
          });
        })
        .catch(action => {
          if (action === 'cancel') {
            let refundCode = code;
            let res = '0';
            dbOrder.postDBRefundExaminel(refundCode, res).then(res => {
              if (res.success) {
                this.getRefundList();
              } else {
                this.$message.error(res.message);
              }
            });
          }
        });
    },
    // 时间格式转换
    fmtDate(date) {
      let dateFn = new Date(date);
      let yy = dateFn.getFullYear();
      let mm = dateFn.getMonth() + 1;
      let dd = dateFn.getDate();
      let hh =
        dateFn.getHours() < 10
          ? '0' + dateFn.getHours()
          : '' + dateFn.getHours();
      let xx =
        dateFn.getMinutes() < 10
          ? '0' + dateFn.getMinutes()
          : '' + dateFn.getMinutes();
      let ss =
        dateFn.getSeconds() < 10
          ? '0' + dateFn.getSeconds()
          : '' + dateFn.getSeconds();
      let time = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + xx + ':' + ss;
      return time;
    }
  }
};
</script>

<style lang="scss" scoped>
.cancellation-detail {
  width: 100%;
  height: 100%;
  letter-spacing: 1px;
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .cancellation-detail-main {
    .header {
      display: flex;
      font-size: 14px;
      margin-bottom: 20px;
      ul {
        margin-right: 100px;
        li {
          padding-top: 10px;
          height: 22px;
          line-height: 22px;
        }
      }

      .right {
        padding-top: 10px;
        .package {
          display: inline-block;
          font-size: 12px;
          padding: 2px 3px;
          background: rgba(#df3445, 0.1);
          color: #df3445;
          margin: 0 5px;
        }
        .code {
          color: #3d74f2;
          cursor: pointer;
        }
      }
    }
    .table-img {
      margin-bottom: 24px;
      .total {
        padding: 8px 0;
        border: 1px solid #f2f6fc;
        border-top: 0px;
        .ul-list {
          width: 426px;
          display: flex;
          justify-content: flex-end;
          width: 100%;
          .list {
            width: 208px;
            display: flex;
            align-items: center;
            font-size: 14px;
            p {
              line-height: 16px;
              padding: 0 5px 0 10px;
            }
            span {
              line-height: 16px;
              color: #df3445;
            }
          }
        }
      }
    }
    .message-title {
      font-size: 14px;
      margin-bottom: 56px;
      .tit {
        line-height: 22px;
        margin-bottom: 12px;
      }
      .message {
        display: flex;
        .ul-list {
          flex: 1;
          .list {
            line-height: 32px;
            .el-button {
              width: 52px;
              height: 32px;
              font-size: 12px;
              font-family: "PingFangSC-Regular";
              font-weight: 400;
              color: rgba(61, 116, 242, 1);
              line-height: 30px;
              letter-spacing: 1px;
              padding: 0;
              span {
                display: inline-block;
                height: 30px;
                line-height: 30px;
                color: red;
              }
            }
          }
        }
      }
    }
    .operations {
      height: 60px;
      position: fixed;
      left: 256px;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 6px 0px rgba(219, 223, 230, 1);
      .button-container {
        height: 32px;
        display: flex;
        justify-content: center;
        .el-button {
          width: 96px;
          letter-spacing: 4px;
          padding: 0;
          text-align: center;
          padding-left: 5px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.cancellation-detail {
  .cancellation-detail-main {
    .table-img {
      .el-input {
        width: 96px;
      }
    }
    .message-title {
      .list {
        .el-input {
          width: 320px;
        }
        .el-dialog {
          height: 400px;
          font-family: "PingFangSC-Regular";
          .el-dialog__header {
            padding: 12px 24px;
            line-height: 24px;
            font-size: 16px;
            color: #606266;
            .el-dialog__headerbtn {
              top: 13px;
            }
          }
          .el-dialog__body {
            padding: 0;
            .border {
              margin: 0 24px;
            }
            .container {
              height: 319px;
              overflow: auto;
              padding: 0 24px;
              .express {
                padding: 8px 0px;
                display: flex;
                .express-p {
                  line-height: 24px;
                  height: 24px;
                  font-size: 14px;
                  font-weight: 400;
                  color: rgba(96, 98, 102, 1);
                  line-height: 24px;
                  letter-spacing: 1px;
                  margin-right: 24px;
                }
              }
              .list {
                padding-left: 14px;
                padding-bottom: 20px;
                li {
                  border-left: 1px solid #f7f7f7;
                  padding-left: 23px;
                  position: relative;
                  color: #919398;
                  i {
                    position: absolute;
                    display: inline-block;
                    left: -5px;
                    width: 9px;
                    height: 9px;
                    border-radius: 50%;
                    background: #c0c4cc;
                  }
                  .space {
                    font-size: 12px;
                    line-height: 17px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                  }
                  .time {
                    font-size: 12px;
                    line-height: 17px;
                    padding-bottom: 5px;
                    border-bottom: 1px solid #f7f7f7;
                  }
                }
              }
              .list li:nth-child(1) {
                i {
                  position: absolute;
                  display: inline-block;
                  left: -8px;
                  width: 15px;
                  height: 15px;
                  border-radius: 50%;
                  background: #3d74f2;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
